import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import accountPropTypes from '../../../states/accounts/propTypes';
import AccountPickerMessage from './AccountPickerMessage';
import accountPickerContent, { contentPropTypes } from './AccountPicker.content';
import AccountPickerCardSelector from './AccountPickerCardSelector';
import withContent from '../../../containers/withContent';
import { canAddFavourite } from '../../../utils/favouriteUtils';
import { getSelectedPaymentId } from '../../../states/payeeSelector/selectors';

const mapState = (state) => ({
	selectedPayeeId: getSelectedPaymentId(state),
});

// prettier-ignore
const getCardClass = listViewSelected =>
	(listViewSelected
		? 'account-picker__items__item--fullWidth'
		: 'account-picker__items__item--col');

const AccountPickerFavouritesView = ({
	favourites,
	listViewSelected,
	content,
	onAccountClick,
	onFavouriteIconClick,
	getIsAccountSelected,
	layoutType,
	selectedPayeeId,
}) => (
	<div className="account-picker__itemscontainer" data-test-id="account-picker-favourites-view">
		{favourites.length === 0 && <AccountPickerMessage message={content.favouritesNoFavouritesText} />}
		<div className="account-picker__items">
			{favourites.map((account) => (
				<div className={`account-picker__items__item ${getCardClass(listViewSelected)}`} key={account.id}>
					<AccountPickerCardSelector
						account={account}
						listViewSelected={listViewSelected}
						onAccountClick={onAccountClick}
						onFavouriteIconClick={onFavouriteIconClick}
						key={account.id}
						getIsAccountSelected={getIsAccountSelected}
						layoutType={layoutType}
						canAddMultiplePayees={!selectedPayeeId}
					/>
				</div>
			))}
		</div>
		{favourites.length > 0 && canAddFavourite(favourites) && (
			<AccountPickerMessage message={content.addMoreFavourites} />
		)}
	</div>
);

AccountPickerFavouritesView.propTypes = {
	favourites: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	listViewSelected: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes),
	onAccountClick: PropTypes.func.isRequired,
	onFavouriteIconClick: PropTypes.func.isRequired,
	getIsAccountSelected: PropTypes.func,
	layoutType: PropTypes.string.isRequired,
	selectedPayeeId: PropTypes.string.isRequired,
};
export default connect(mapState)(withContent({ content: accountPickerContent })(AccountPickerFavouritesView));
